/**************************************************************************************************************************
 Copyright (c) 2023 WorkEarly Results LLP

     Name: app.ts
   Author: Harikrishnan Gangadharan
 Comments: 

/**************************************************************************************************************************
 DEFINITIONS
***************************************************************************************************************************/
const Name = 'Transcad';
const Tagline = 'A perfect reflection of your dream';

const SlideInterval = 10000;

const App = {
  Name,
  Tagline,
  SlideInterval
};

export default App;
